// extracted by mini-css-extract-plugin
export default {"root":"FatV7","link":"a_uDj"};